import { observable, computed, action, makeObservable, } from 'mobx';
export class AirlineStore {
    constructor() {
        Object.defineProperty(this, "_airlines", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        makeObservable(this, {
            airlines: computed,
            setAirlines: action,
        });
    }
    get airlines() {
        return this._airlines;
    }
    setAirlines(airlines) {
        this._airlines.replace(airlines.map((airline) => airline));
    }
}
//# sourceMappingURL=AirlineStore.js.map